module.exports = __webpack_public_path__ + "static/media/HCMM415.98857020.jpg";